import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { axiosPrivate } from 'modules/networkTools/networkTools';

export type ConsentMessage = {
  id: number;
  text: string;
};

export const getClientConsentMessage = createAsyncThunk(
  'clientConsent/getClientConsentMessage',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.get('clients/consent');
      return response.data as ConsentMessage;
    } catch (error: any | AxiosError) {
      if (error.response && error.response.data.errors) {
        return rejectWithValue(error.response.data.errors);
      }
      return rejectWithValue(error.message);
    }
  }
);
